import { useEffect } from "react";
import { useLocation } from "@tanstack/react-router";
import { trackPageView } from "@/lib/analytics";

// App é uma SPA: sem isso, o GA4 só veria a 1ª página carregada — cada
// navegação client-side precisa disparar o page_view manualmente.
export function AnalyticsPageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
}
